<template>
	<div class="login-page">
		<!-- 全局背景拓扑装饰 -->
		<div class="bg-decoration">
			<div class="dot d1"></div>
			<div class="dot d2"></div>
			<div class="dot d3"></div>
			<div class="dot d4"></div>
			<div class="dot d5"></div>
			<div class="line l1"></div>
			<div class="line l2"></div>
			<div class="line l3"></div>
			<div class="shape s1"></div>
			<div class="shape s2"></div>
			<div class="shape s3"></div>
		</div>

		<!-- 登录核心卡片 -->
		<div class="login-card">
			<div class="card-header">
				<span class="brand">田园智城</span>
				<span class="company">杭州田园智城科技管理有限公司</span>
			</div>

			<!-- 备案合规说明【优化后文案】 -->
			<div class="law-desc">
				本平台为自研数字化资料管理工具，仅供线下签约合作机构内部人员内部使用；无自主注册通道，账号由合作机构管理员统一创建分配；仅提供内部资料查阅、数据统计、配套信息化管理服务，平台不面向外部公众开放运营，不开展各类面向公众的经营性线上服务。
			</div>

			<h1 class="main-title">欢迎登录</h1>
			<p class="sub-title">田园智城内部管理系统</p>

			<el-form
				:model="loginForm"
				ref="loginForm"
				:rules="loginRules"
				label-width="0"
				class="form-wrap"
			>
				<el-form-item prop="tel">
					<el-input
						v-model="loginForm.tel"
						maxlength="11"
						clearable
						placeholder="请输入手机号"
					></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input
						v-model="loginForm.password"
						type="password"
						show-password
						clearable
						maxlength="10"
						placeholder="请输入密码"
						@keyup.enter.native="handleLogin"
					></el-input>
				</el-form-item>

				<el-form-item>
					<el-button class="login-submit" type="primary" @click="handleLogin">机构系统登录</el-button>
				</el-form-item>

				<div class="form-extra">
					<el-checkbox v-model="autoLogin" class="remember-pwd">记住我的登录</el-checkbox>
				</div>
			</el-form>
		</div>

		<!-- 底部备案信息 -->
		<div class="login_footer">
			<div class="footer">
				<a href="http://beian.miit.gov.cn" target="_blank">网站备案号：浙ICP备2026049996号</a>
				<div class="beian-tip">本网站仅为合作机构内部管理系统，不面向全网公众开放</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api from "../axios/interface";
	export default {
		name: "Login",
		data() {
			const checkTel = (rule, value, callback) => {
				if (!value) {
					callback(new Error("请输入手机号码"));
				} else if (!/^1\d{10}$/.test(value)) {
					callback(new Error("手机号码不合法"));
				} else {
					callback();
				}
			};
			const checkPwd = (rule, value, callback) => {
				if (!value) {
					callback(new Error("请输入密码"));
				} else {
					callback();
				}
			};
			return {
				autoLogin: true,
				loginForm: {
					tel: "",
					password: ""
				},
				loginRules: {
					tel: [{ validator: checkTel, trigger: "blur" }],
					password: [{ validator: checkPwd, trigger: "blur" }]
				}
			};
		},
		methods: {
			handleLogin() {
				this.$refs.loginForm.validate((valid) => {
					if (!valid) return;
					this.$axios.post(api.LoginIn, {
						username: this.loginForm.tel,
						password: this.loginForm.password
					}, { hideMessage: true })
						.then(res => {
							const userInfo = {
								...res.result.userInfo,
								token: res.result.token,
								autoLogin: this.autoLogin
							};
							this.$store.commit("updateUserInfo", userInfo);

							// ============ 新增手机号判断逻辑 ============
							const adminPhoneList = ["15810431440", "17760701189"];
							let targetPath = "/home";
							if (adminPhoneList.includes(this.loginForm.tel)) {
								localStorage.setItem("accountType", "sys");
								targetPath = "/sys/unit";
							} else {
								localStorage.setItem("accountType", "student");
								targetPath = "/home";
							}
							this.$router.push(targetPath);
							this.$message.success("登录成功");
						})
						.catch(err => {
							let errorMsg = "登录失败，请稍后再试";
							if (err.message) {
								errorMsg = err.message === "用户名或密码错误" ? "密码错误" : err.message;
							}
							this.$message.error(errorMsg);
						});
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.login-page {
		width: 100%;
		height: 100vh;
		position: fixed;
		background: linear-gradient(135deg, #1f5b8a 0%, #0d3555 100%);
		color: #ffffff;
		overflow: hidden;

		.bg-decoration {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			pointer-events: none;

			@keyframes floatDot {
				0%, 100% {
					opacity: 0.65;
					transform: scale(1);
				}
				50% {
					opacity: 1;
					transform: scale(1.15);
				}
			}

			.dot {
				width: 9px;
				height: 9px;
				border-radius: 50%;
				background: rgba(255,255,255,0.65);
				position: absolute;
				animation: floatDot 6s infinite ease-in-out;
			}

			.d1 { top: 22%; left: 22%; animation-delay: 0s; }
			.d2 { top: 16%; left: 46%; animation-delay: 1.2s; }
			.d3 { top: 32%; left: 64%; animation-delay: 2.4s; }
			.d4 { top: 52%; left: 34%; animation-delay: 3.6s; }
			.d5 { top: 44%; left: 72%; animation-delay: 4.8s; }

			.line {
				position: absolute;
				height: 1px;
				background: rgba(255,255,255,0.18);
				transform-origin: left center;
			}

			.l1 { width: 140px; top: 23%; left: 23%; transform: rotate(26deg); }
			.l2 { width: 170px; top: 18%; left: 47%; transform: rotate(-32deg); }
			.l3 { width: 150px; top: 34%; left: 65%; transform: rotate(20deg); }

			.shape {
				position: absolute;
				border: 1px solid rgba(255,255,255,0.35);
			}

			.s1 { width: 32px; height: 32px; top: 12%; left: 76%; border-radius: 4px; }
			.s2 { width: 26px; height: 26px; top: 56%; left: 28%; transform: rotate(45deg); }
			.s3 { width: 36px; height: 36px; border-radius: 50%; top: 40%; left: 78%; }
		}

		.login-card {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 90vw;
			max-width: 480px;
			padding: 48px 44px;
			background: rgba(255, 255, 255, 0.12);
			backdrop-filter: blur(10px) saturate(130%);
			-webkit-backdrop-filter: blur(10px) saturate(130%);
			border: 1px solid rgba(255, 255, 255, 0.22);
			border-radius: 16px;
			box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);

			.card-header {
				display: flex;
				align-items: baseline;
				gap: 8px;
				margin-bottom: 16px;

				.brand {
					font-size: 24px;
					font-weight: 700;
					letter-spacing: 0.5px;
					color: #ffffff;
					text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
				}
				.company {
					font-size: 15px;
					color: rgba(255, 255, 255, 0.9);
				}
			}

			.law-desc {
				font-size: 13px;
				line-height: 1.75;
				color: rgba(255, 255, 255, 0.96);
				background: rgba(20, 50, 80, 0.45);
				padding: 15px;
				border-radius: 8px;
				margin-bottom: 24px;
			}

			.main-title {
				font-size: 42px;
				font-weight: 700;
				margin: 0;
				letter-spacing: 0.5px;
				color: #ffffff;
				text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
			}
			.sub-title {
				font-size: 21px;
				font-weight: 500;
				margin: 6px 0 26px;
				color: rgba(255, 255, 255, 0.92);
				text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
			}

			.form-wrap {
				/deep/.el-form-item {
					margin-bottom: 18px;
				}

				/deep/.el-input__inner {
					height: 52px;
					background: #fff;
					color: #333;
					border: none;
					font-size: 17px;
					border-radius: 10px;
					transition: all 0.22s ease;

					&:hover {
						box-shadow: 0 0 0 2px rgba(255, 154, 0, 0.35);
					}

					&:focus {
						box-shadow: 0 0 0 3px rgba(255, 154, 0, 0.45);
					}
				}

				/deep/.el-form-item__error {
					color: #ffffff;
					font-size: 13px;
				}
			}

			.login-submit {
				width: 100%;
				background-color: #ff9a00;
				border: none;
				font-size: 17px;
				height: 52px;
				border-radius: 10px;
				font-weight: 600;
				box-shadow: 0 4px 12px rgba(255, 154, 0, 0.45);
				transition: all 0.22s ease;

				&:hover {
					transform: translateY(-1px);
					box-shadow: 0 6px 16px rgba(255, 154, 0, 0.55);
				}

				&:active {
					transform: translateY(0);
					box-shadow: 0 3px 10px rgba(255, 154, 0, 0.35);
				}
			}

			.form-extra {
				display: flex;
				align-items: center;
				margin-top: 16px;
				font-size: 15px;

				/deep/ .remember-pwd {
					padding: 6px 0;

					.el-checkbox__label {
						color: #fff;
					}
					.el-checkbox__input.is-checked .el-checkbox__inner {
						background-color: #ffffff;
						border-color: #ffffff;
					}
					.el-checkbox__inner::after {
						border: 1px solid #1f5b8a;
					}
				}
			}
		}

		.login_footer {
			position: absolute;
			bottom: 24px;
			left: 50%;
			transform: translateX(-50%);
			text-align: center;
			font-size: 12px;
			line-height: 1.6;
			width: 90vw;

			a {
				color: #ffffff;
			}

			.beian-tip {
				margin-top: 4px;
				opacity: 0.78;
			}
		}
	}

	@media screen and (max-width: 1366px) {
		.login-page {
			.login-card {
				padding: 40px 36px;
			}
			.main-title {
				font-size: 38px;
			}
			.sub-title {
				font-size: 20px;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.login-page {
			.login-card {
				padding: 32px 28px;
				max-width: 92vw;
			}
			.main-title {
				font-size: 34px;
			}
			.law-desc {
				padding: 12px;
			}
		}
	}
</style>
